import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=1b41acb5&scoped=true"
import script from "./Merchant.vue?vue&type=script&lang=js"
export * from "./Merchant.vue?vue&type=script&lang=js"
import style0 from "./Merchant.vue?vue&type=style&index=0&id=1b41acb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b41acb5",
  null
  
)

export default component.exports